import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import Notice from "../views/page/board/Notice";
import NoticeWrite from "../views/page/board/NoticeWrite";
import MedicalTeam from "../views/page/board/MedicalTeam";
import MedicalTeamWrite from "../views/page/board/MedicalTeamWrite";
import Picture from "../views/page/board/Picture";
import PictureWrite from "../views/page/board/PictureWrite";
import ProductReview from "../views/page/board/ProductReview";
import ProductReviewDetail from "../views/page/board/ProductReviewDetail";
import Review from "../views/page/board/Review";
import ReviewDetail from "../views/page/board/ReviewDetail";
import Faq from "../views/page/board/Faq";
import FaqWrite from "../views/page/board/FaqWrite";
import FaqCategory from "../views/page/board/FaqCategory";

function RouterBoard() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/Board/Notice" replace />} />
        <Route exact path="/Notice" element={<Notice />} />
        <Route exact path="/Notice/Write" element={<NoticeWrite />} />
        <Route exact path="/Notice/Write/:board_seq" element={<NoticeWrite />} />
        <Route exact path="/Faq" element={<Faq />} />
        <Route exact path="/Faq/Category" element={<FaqCategory />} />
        <Route exact path="/Faq/Write" element={<FaqWrite />} />
        <Route exact path="/Faq/Write/:board_seq" element={<FaqWrite />} />
        <Route exact path="/MedicalTeam" element={<MedicalTeam />} />
        <Route exact path="/MedicalTeam/Write" element={<MedicalTeamWrite />} />
        <Route exact path="/Picture" element={<Picture />} />
        <Route exact path="/Picture/Write" element={<PictureWrite />} />
        <Route exact path="/ProductReview" element={<ProductReview />} />
        <Route exact path="/ProductReview/Detail" element={<ProductReviewDetail />} />
        <Route exact path="/Review" element={<Review />} />
        <Route exact path="/Review/Detail" element={<ReviewDetail />} />
      </Routes>
    </>
  );
}

export default RouterBoard;
